<template>
  <div class="tw:shadow-mdLg tw:bg-white tw:w-full tw:z-40 tw:fixed" data-testid="rate-connect-onboarding-header">
    <div class="tw:grow tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:m-auto tw:md:px-4">
      <div class="tw:flex tw:justify-between tw:relative">
        <div class="tw:hidden tw:lg:flex tw:items-center tw:min-w-fit">
          <img
            :src="RateConnectLogo"
            alt="Rate Connect"
            class="tw:hidden tw:sm:flex tw:w-[230px] tw:h-[30px] tw:sm:h-[22px] tw:md:ml-0 tw:ml-2 tw:mr-2"
          />

          <div class="tw:mx-2 tw:h-full tw:w-[1px] tw:bg-gray-200 tw:my-3" />
          <div class="tw:hidden tw:lg:flex tw:gap-x-2 tw:items-center tw:pl-4 tw:py-3">
            <img
              :src="`https://imgcy.trivago.com/c_fill,d_dummy.jpeg,e_sharpen:60,f_auto,h_32,q_auto,w_32/${currentAccommodation?.mainImageUrls?.imagePath || 'dummy.jpeg'}`"
              :alt="currentAccommodation?.name"
              class="tw:rounded-lg tw:w-[32px] tw:h-[32px]"
            />
            <div class="tw:hidden tw:lg:flex tw:flex-col tw:gap-y-[2px]">
              <p class="tw:font-bold tw:text-sm tw:leading-tight tw:truncate tw:max-w-[160px]">
                {{ currentAccommodation?.name }}
              </p>
              <p class="tw:text-xs">{{ `ID: ${currentAccommodation?.accommodationId}` }}</p>
            </div>
          </div>
        </div>
        <div class="tw:flex tw:items-center tw:w-full tw:lg:w-auto">
          <PartnerSelector
            :withShadow="false"
            :partners="activePartnersData"
            :selectedPartner="selectedPartner"
            :isAdmin="hasAdminOrSupport"
            @selectPartner="selectPartner"
            @startCreatingCampaign="startCreatingCampaign"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

import PartnerSelector from '@/components/rateConnect/onboarding/PartnerSelector.vue'

import { selectedAccommodationId, useAccommodationsByOrgId } from '@/layouts/queries'
import { usePartners } from '@/components/rateConnect/queries'
import { useSetup } from '../setup/useSetup'
import { useSessionValues } from '@/composables/useSessionValues'

import appAnalytics from '@/utils/tracking'
import { useRateConnectOnboardingData } from './useRateConnectOnboardingData'

const RateConnectLogo = new URL('/src/assets/img/logos/rate-connect-logo.svg', import.meta.url)

const store = useStore()
const router = useRouter()
const selectedOrganisationId = computed(() => store.state.session.selectedOrganisation?.id)
const { hasAdminOrSupport } = useSessionValues()
const { currentAccommodation } = useAccommodationsByOrgId(selectedOrganisationId)

const { selectedPartner, selectPartner } = useSetup()
const { activePartnersData } = usePartners(selectedAccommodationId)
const { resetShowAlternateHeader } = useRateConnectOnboardingData()
const startCreatingCampaign = () => {
  resetShowAlternateHeader()
  if (hasAdminOrSupport.value) {
    router.push({ name: 'rate-connect-setup' })
    appAnalytics.track(appAnalytics.events.RC_CREATE_CAMPAIGN_CLICKED, {
      source: 'sticky-banner',
      accommodationId: selectedAccommodationId.value,
    })
  } else {
    store.dispatch('session/logout', '/rate-connect/no-campaign?loginAsAdmin=true')
    appAnalytics.track(appAnalytics.events.RC_LOGIN_AS_ADMIN_CLICKED, {
      accommodationId: selectedAccommodationId.value,
    })
  }
}
</script>
